<template>
  <div>
    <div class="neutral--text text--tone-400 text-label-m mb-2">
      {{ label }}
    </div>
    <BaseButton
      block
      color="neutral tone-200"
      @click="openDialog = true"
      outlined
      :height="56"
      thin-borders
      class="white"
    >
      <div class="d-flex w-100 align-center">
        <div class="neutral--text text-body-m">
          {{ textValue }}
        </div>
        <v-spacer></v-spacer>
        <font-awesome-icon
          icon="fa-regular fa-arrow-right"
          class="brand-primary--text text--tone-400"
          size="lg"
        />
      </div>
    </BaseButton>
    <BaseDialog
      fullscreen
      :value="openDialog"
      @close="openDialog = false"
    >
      <template #content>
        <BaseFullscreenModal
          @close="openDialog = false"
          class="px-6"
          :submit-button-text="submitButtonText"
          @confirm="applyFilters"
        >
          <template #header>
            <BaseSubheader>
              <span class="neutral--text text--tone-900">
                {{ modalTitle }}
              </span>
            </BaseSubheader>
          </template>
          <template #content>
            <BaseList
              :items="items"
              v-bind="$attrs"
              v-on="$listeners"
              class="neutral tone-100"
              style="margin-bottom: 93px"
              :multiple="multiple"
              @change="$emit('change', $event)"
            />
          </template>
        </BaseFullscreenModal>
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import BaseDialog from './BaseDialog.vue';
import BaseSubheader from './BaseSubheader.vue';
import BaseButton from './BaseButton.vue';
import BaseList from './BaseList.vue';
import BaseFullscreenModal from './BaseFullscreenModal.vue';

export default {
  components: {
    BaseDialog,
    BaseSubheader,
    BaseButton,
    BaseList,
    BaseFullscreenModal,
  },
  data() {
    return {
      value: null,
      openDialog: false,
      selectedFilters: [],
    };
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
    submitButtonText: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    textValue: {
      type: String,
      default: 'Sélectionnez un filtre',
    },
  },
  methods: {
    applyFilters() {
      this.openDialog = false;
      this.$emit('filter', this.selectedFilters);
    },
  },
};
</script>
